import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  rubricasSintetico: filtros => {
    return Vue.http.get('/api/relatoriorubricasacessoespecial/sintetico',
      {
        params: filtros
      })
      .then(resposta => resposta.body);
  },
  rubricasAnalitico: filtros => {
    return Vue.http.get('/api/relatoriorubricasacessoespecial/analitico',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idConta: filtros.idConta,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idMetaEtapa: filtros.idMetaEtapa,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentos: filtros => {
    return Vue.http.get('/api/RelatorioLancamentosAcessoEspecial',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          rendimento: filtros.rendimento,
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentosExcel: filtros => {
    return Vue.http.get('/api/RelatorioLancamentosAcessoEspecial/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          rendimento: filtros.rendimento,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return ''; 
        
        return salvarArquivo(response);
      });
  },
  controleItem: filtros => {
    return Vue.http.get('/api/relatoriocontroleitemacessoespecial',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        }
      })
      .then(resposta => resposta.body);
  }
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/acesso-especial/relatorio/relatorio.servico.js